<div class="mb-3">
  <h1 class="fs-5 fw-bold mb-0">Conversion Log</h1>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-header fw-bold bg-tertiary p-3 border-0">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-filter me-2 text-primary"></i>Filters</h2></div>
    <div class="card-body">

      <app-log-filters [filters]="filters" (init)="fetchAll()"></app-log-filters>

      <div class="row g-3 align-items-end mb-4">
        <div class="col">
          <label for="cid" class="form-label">CID</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-filter"></i></span>
            <input type="text" class="form-control" [(ngModel)]="filters['cid']" [ngModelOptions]="{standalone: true}">
          </div>
        </div>
        <div class="col">
          <label for="filter-goal" class="form-label">Goal</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-bar-chart-steps"></i></span>
            <app-dropdown-select (ngModelChange)="updateGoals()" [multiple]="true" [(ngModel)]="filters['goalId']"
              [ngModelOptions]="{standalone: true}">
              @for (goal of goalList; track goal) {
                <app-dropdown-select-option [value]="goal.id">
                  {{ goal.identifier }}
                </app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>
        <div class="col">
          <label for="filter-goal-type" class="form-label">Goal Type</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-bar-chart-steps"></i></span>
            <app-dropdown-select [multiple]="true" [(ngModel)]="filters['goalTypeId']"
              [ngModelOptions]="{standalone: true}">
              @for (goalType of goalTypeList; track goalType) {
                <app-dropdown-select-option [value]="goalType.id">
                  {{ goalType.goalIdentifier }} / {{ goalType.identifier }}
                </app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>
        <div class="col">
          <label for="status" class="form-label">Status</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-check"></i></span>
            <select [(ngModel)]="filters['accepted']" [ngModelOptions]="{standalone: true}" class="form-control">
              <option [ngValue]="null">All</option>
              <option [ngValue]="true">Accepted</option>
              <option [ngValue]="false">Rejected</option>
            </select>
          </div>
        </div>
        <div class="col">
          <label for="paid" class="form-label">Paid</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-cash-coin"></i></span>
            <select [(ngModel)]="filters['paid']" [ngModelOptions]="{standalone: true}" class="form-control">
              <option [ngValue]="null">All</option>
              <option [ngValue]="true">Paid only</option>
              <option [ngValue]="false">Unpaid only</option>
            </select>
          </div>
        </div>
        <div class="col" *isGranted="['ROLE_API_EMAIL_PLAINTEXT']">
          <label for="email" class="form-label">Email</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-envelope"></i></span>
            <input type="text" class="form-control" [(ngModel)]="filters['email']" [ngModelOptions]="{standalone: true}">
          </div>
        </div>
      </div>

      <div class="row g-3 align-items-end mb-4">
        <div class="col-auto ms-auto">
          <button (click)="downloadCsv()" [disabled]="downloading" class="btn btn-secondary fw-bold me-2">
            @if (downloading) {
              <app-csv-export-progress [current]="exportProgress?.current ?? 0"
                                       [total]="exportProgress?.total ?? 0">
              </app-csv-export-progress>
            } @else {
              CSV
            }
          </button>
          <button type="submit" class="btn btn-primary fw-bold" (click)="applyFilters()">Apply Filters</button>
        </div>
      </div>

      <app-display-table-column [data]="displayedColumns"></app-display-table-column>

      <div class="table-responsive">
        <table class="table table-striped table-hover table-fixed-columns my-4" [checkboxTable]="checkboxTable"
          id="conversions">
          <thead>
            <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
              <th>
                <app-checkbox-all-table></app-checkbox-all-table>
              </th>
              <th tableSorterHeader="id">ID</th>
              <th tableSorterHeader="createdAt">Date</th>
              @if (displayedColumns.conversionDate) {
                <th>Conversion Date</th>
              }
              @if (displayedColumns.goal) {
                <th>Goal</th>
              }
              @if (displayedColumns.goalType) {
                <th>Goal Type</th>
              }
              @if (displayedColumns.amount) {
                <th>Amount</th>
              }
              @if (displayedColumns.payout) {
                <th>Payout</th>
              }
              @if (displayedColumns.customPayout) {
                <th>Custom payout</th>
              }
              @if (displayedColumns.payout) {
                <th>Age rule</th>
              }
              @if (displayedColumns.cid) {
                <th>CID</th>
              }
              @if (displayedColumns.lead) {
                <th>Lead</th>
              }
              @if (displayedColumns.product) {
                <th>Brand</th>
              }
              @if (displayedColumns.offer) {
                <th>Offer</th>
              }
              @if (displayedColumns.conversionType) {
                <th>Conversion Type</th>
              }
              @if (displayedColumns.accountType) {
                <th>Account Type</th>
              }
              @if (displayedColumns.accountManager) {
                <th>Account Manager</th>
              }
              @if (displayedColumns.landingPage) {
                <th>Promotion link</th>
              }
              @if (displayedColumns.partner) {
                <th>Partner</th>
              }
              @if (displayedColumns.subid) {
                <th>SubID</th>
              }
              @if (displayedColumns.tc1) {
                <th>Tracker 1</th>
              }
              @if (displayedColumns.tc2) {
                <th>Tracker 2</th>
              }
              @if (displayedColumns.tc3) {
                <th>Tracker 3</th>
              }
              @if (displayedColumns.tc4) {
                <th>Tracker 4</th>
              }
              @if (displayedColumns.clickid) {
                <th>Click ID</th>
              }
              @if (displayedColumns.gclid) {
                <th>GCLID</th>
              }
              @if (displayedColumns.fbclid) {
                <th>FBCLID</th>
              }
              @if (displayedColumns.fbpxid) {
                <th>FBPXID</th>
              }
              @if (displayedColumns.msclkid) {
                <th>MSCLKID</th>
              }
              @if (displayedColumns.mspxid) {
                <th>MSPXID</th>
              }
              @if (displayedColumns.twclid) {
                <th>TWCLID</th>
              }
              @if (displayedColumns.twpxid) {
                <th>TWPXID</th>
              }
              @if (displayedColumns.ttclid) {
                <th>TTCLID</th>
              }
              @if (displayedColumns.ttpxid) {
                <th>TTPXID</th>
              }
              @if (displayedColumns.source) {
                <th>Source</th>
              }
              @if (displayedColumns.ip) {
                <th>IP</th>
              }
              @if (displayedColumns.referer) {
                <th>Referer</th>
              }
              @if (displayedColumns.customerName) {
                <th>Name</th>
              }
              @if (displayedColumns.customerEmail) {
                <th>Email</th>
              }
              @if (displayedColumns.customerLanguage) {
                <th>Language</th>
              }
              @if (displayedColumns.customerCountry) {
                <th>Country</th>
              }
              @if (displayedColumns.uniqueReference) {
                <th>Unique Reference</th>
              }
              <th>Status</th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (conversion of conversions; track conversion) {
              <tr [ngClass]="getClass(conversion)">
                <td>
                  <app-checkbox-table [value]="conversion.id"></app-checkbox-table>
                </td>
                <td>{{ conversion.id }}</td>
                <td>{{ conversion.createdAt | parisDate }}</td>
                @if (displayedColumns.conversionDate) {
                  <td>{{ conversion.conversionDate | parisDate }}</td>
                }
                @if (displayedColumns.goal) {
                  <td>{{ conversion.goalName }}</td>
                }
                @if (displayedColumns.goalType) {
                  <td>{{ conversion.goalTypeName }}</td>
                }
                @if (displayedColumns.amount) {
                  <td>{{ getAmount(conversion) | currency:2:getCurrency(conversion) }}</td>
                }
                @if (displayedColumns.payout) {
                  <td [class.custom-payout-color]="conversion.customPayout">
                    @if (conversion.currencyPayout !== null && conversion.payoutCurrency) {
                      {{ getCurrencyPayout(conversion) | currency:2:conversion.payoutCurrency.isoCode }}
                    } @else {
                      {{ getPayout(conversion) | currency:2 }}
                    }
                  </td>
                }
                @if (displayedColumns.customPayout) {
                  <td>
                    @if (conversion.customPayout) {
                      @if (conversion.customPayout.payoutAmount) {
                        {{ conversion.customPayout.payoutAmount | currency:2:$safeNavigationMigration(conversion.customPayout.currency?.isoCode) }}
                      }
                      @if (conversion.customPayout.payoutPercent) {
                        {{ conversion.customPayout.payoutPercent }}%
                      }
                    }
                  </td>
                }
                @if (displayedColumns.payout) {
                  <td
                    [class.text-success]="!conversion.underMinAgeForPayout"
                    [class.text-danger]="conversion.underMinAgeForPayout"
                    class="py-0 pt-1 smaller-line">
                    @if (conversion.underMinAgeForPayout !== null) {
                      @if (conversion.underMinAgeForPayout) {
                        <i class="bi bi-person-fill-check fs-4"></i>
                      }
                      @if (!conversion.underMinAgeForPayout) {
                        <i class="bi bi-person-fill-x fs-4"></i>
                        }<br>
                        < {{ conversion.minAgeForPayout }}
                      }
                    </td>
                  }
                  @if (displayedColumns.cid) {
                    <td>
                      <a href="javascript:void(0)" (click)="openClickDetail(conversion)">{{ conversion.cid }}</a>
                    </td>
                  }
                  @if (displayedColumns.lead) {
                    <td>
                      <a href="javascript:void(0)" (click)="openLeadDetail(conversion)">{{ conversion.leadId }}</a>
                    </td>
                  }
                  @if (displayedColumns.product) {
                    <td>{{ conversion.product }}</td>
                  }
                  @if (displayedColumns.offer) {
                    <td>{{ conversion.offer }}</td>
                  }
                  @if (displayedColumns.conversionType) {
                    <td>{{ conversion.offer?.conversionType }}</td>
                  }
                  @if (displayedColumns.accountType) {
                    <td>{{ conversion.partner?.accountType }}</td>
                  }
                  @if (displayedColumns.accountManager) {
                    <td>{{ conversion.partner?.accountManager }}</td>
                  }
                  @if (displayedColumns.landingPage) {
                    <td>{{ conversion.landingPage }}</td>
                  }
                  @if (displayedColumns.partner) {
                    <td>{{ conversion.partner }}</td>
                  }
                  @if (displayedColumns.subid) {
                    <td>{{ conversion.subid }}</td>
                  }
                  @if (displayedColumns.tc1) {
                    <td>{{ conversion.tc1 }}</td>
                  }
                  @if (displayedColumns.tc2) {
                    <td>{{ conversion.tc2 }}</td>
                  }
                  @if (displayedColumns.tc3) {
                    <td>{{ conversion.tc3 }}</td>
                  }
                  @if (displayedColumns.tc4) {
                    <td>{{ conversion.tc4 }}</td>
                  }
                  @if (displayedColumns.clickid) {
                    <td>{{ conversion.clickid }}</td>
                  }
                  @if (displayedColumns.gclid) {
                    <td>{{ conversion.gclid }}</td>
                  }
                  @if (displayedColumns.fbclid) {
                    <td>{{ conversion.fbclid }}</td>
                  }
                  @if (displayedColumns.fbpxid) {
                    <td>{{ conversion.fbpxid }}</td>
                  }
                  @if (displayedColumns.msclkid) {
                    <td>{{ conversion.msclkid }}</td>
                  }
                  @if (displayedColumns.mspxid) {
                    <td>{{ conversion.mspxid }}</td>
                  }
                  @if (displayedColumns.twclid) {
                    <td>{{ conversion.twclid }}</td>
                  }
                  @if (displayedColumns.twpxid) {
                    <td>{{ conversion.twpxid }}</td>
                  }
                  @if (displayedColumns.ttclid) {
                    <td>{{ conversion.ttclid }}</td>
                  }
                  @if (displayedColumns.ttpxid) {
                    <td>{{ conversion.ttpxid }}</td>
                  }
                  @if (displayedColumns.source) {
                    <td>{{ conversion.source }}</td>
                  }
                  @if (displayedColumns.ip) {
                    <td>{{ conversion.ip }}</td>
                  }
                  @if (displayedColumns.referer) {
                    <td>{{ conversion.referer }}</td>
                  }
                  @if (displayedColumns.customerName) {
                    <td>{{ conversion.getFullCustomerName() }}</td>
                  }
                  @if (displayedColumns.customerEmail) {
                    <td>{{ conversion.email }}</td>
                  }
                  @if (displayedColumns.customerLanguage) {
                    <td>{{ conversion.language }}</td>
                  }
                  @if (displayedColumns.customerCountry) {
                    <td class="text-nowrap">
                      @if (conversion.country) {
                        <img [ngSrc]="countryService.getFlag(conversion.country)" [alt]="conversion.country"
                          [title]="conversion.country" width="24" height="24" class="me-1">{{ conversion.country }}
                      }
                    </td>
                  }
                  @if (displayedColumns.uniqueReference) {
                    <td>{{ conversion.uniqueReference }}</td>
                  }
                  <td>
                    @if (conversion.accepted) {
                      <span class="badge text-bg-success rounded-pill">Accepted</span>
                    }
                    @if (!conversion.accepted) {
                      <span class="badge text-bg-danger rounded-pill">Rejected</span>
                    }
                  </td>
                  <td class="p-0 pt-1 fs-3">
                    @if (conversion.private) {
                      <span class="text-danger" title="Private conversion"><i
                      class="bi bi-eye-slash"></i></span>
                    }
                    @if (!conversion.private) {
                      <span class="text-success" title="Public conversion"><i
                      class="bi bi-eye"></i></span>
                    }
                  </td>
                  <td>
                    @if (conversion.paid) {
                      <span class="text-success" title="Paid conversion"><i
                      class="bi bi-currency-euro"></i></span>
                    }
                  </td>
                  <td>
                    @if (conversion.id) {
                      <button (click)="openDetail(conversion)" class="btn btn-primary btn-sm">
                        <i class="bi bi-eye-fill"></i>
                      </button>
                    }
                    <ng-container *isGranted="['ROLE_API_CONVERSION_WRITE']">
                      @if (conversion.id && !conversion.paid && !conversion.accepted) {
                        <button (click)="accept(conversion,true)"
                          class="btn btn-success btn-sm ms-2" appConfirm appTooltip="Accept conversion">
                          <i class="bi bi-check-circle-fill"></i>
                        </button>
                      }
                      @if (conversion.id && !conversion.paid && conversion.accepted) {
                        <button (click)="accept(conversion,false)"
                          class="btn btn-danger btn-sm ms-2" appConfirm appTooltip="Reject conversion">
                          <i class="bi bi-x-circle-fill"></i>
                        </button>
                      }
                    </ng-container>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <div class="d-flex" *isGranted="['ROLE_API_CONVERSION_WRITE']">
          <select class="form-select w-auto" [(ngModel)]="batchAction">
            <option disabled value="">Select batch action</option>
            <option value="accept-conversion">Accept conversion</option>
            <option value="reject-conversion">Reject conversion</option>
            <option value="adjust-payout">Adjust payout</option>
          </select>
          <button type="button" class="btn btn-primary fw-bold ms-1" (click)="submitBatch()"
            [disabled]="!batchAction">OK
          </button>
        </div>

        <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
      </div>
    </div>
